var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { utilPackage } from "../../../utils/utilPackage";
import { TypeActionPackageInfo } from "./actionSetPurchasePackageInfo";
var initial = {
    packageIdToType: new Map(),
    packages: new Map(),
    purchasedPackages: new Map(),
};
export var reducerPurchasePackageInfoReceived = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionPackageInfo.SetPurchaseInfo: {
            if (action.packages !== undefined) {
                var packages = new Map();
                for (var _i = 0, _a = action.packages; _i < _a.length; _i++) {
                    var currentPackage = _a[_i];
                    if (currentPackage.typeId) {
                        packages.set(currentPackage.typeId, currentPackage);
                    }
                }
                return __assign({}, state, { purchasedPackages: packages || new Map() });
            }
            return __assign({}, state);
        }
        case TypeActionPackageInfo.Purchased: {
            var purchasedPackages = state.purchasedPackages;
            var updatedPackage = purchasedPackages.get(action.packageId);
            if (!updatedPackage) {
                var newPackage = {
                    amount: Long.ONE,
                    typeId: action.packageId,
                };
                purchasedPackages.set(action.packageId, newPackage);
            }
            else {
                updatedPackage.amount = updatedPackage.amount
                    ? updatedPackage.amount.add(Long.ONE)
                    : Long.ONE;
                purchasedPackages.set(action.packageId, updatedPackage);
            }
            return __assign({}, state, { purchasedPackages: purchasedPackages });
        }
        case TypeActionPackageInfo.SetPackageInfo: {
            utilPackage.setPackages(state.packages, state.packageIdToType, action.packages);
        }
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/purchase-packages/reducerPackageInfo.ts
// module id = 2541
// module chunks = 3